import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getAuth0State } from './auth'
import TheNavigationDrawer from './components/TheNavigationDrawer.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

inject('Auth')

const authState = getAuth0State()
const router = useRouter()

// TODO vuetify 3 navbar, replace as soon as available
const showCollapsed = computed((): boolean => {
  // collapse navbar if editor is active
  return /automations\//.test(router.currentRoute.value.path)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_unref(authState).isAuthenticated)
        ? (_openBlock(), _createBlock(TheNavigationDrawer, {
            key: 0,
            "show-collapsed": _unref(showCollapsed)
          }, null, 8, ["show-collapsed"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, {
        class: _normalizeClass(_unref(authState).isAuthenticated ? (_unref(showCollapsed) ? 'collapsedStyle' : 'defaultStyle') : 'loginStyle')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})